import { Trans, useTranslation } from 'react-i18next';
import { UserTypeEnum } from '../../../types/enums/User';
import { Text } from '@resideo/blueprint-react';
import React from 'react';
import { DisabledLink } from './DisabledLink';

const DisabledLinks = ({ userType, setFieldTouched }): JSX.Element => {
  const { t } = useTranslation();
  const isPartnerLike =
    userType === UserTypeEnum.PARTNER || userType === UserTypeEnum.DISTRIBUTOR;
  return (
    <>
      {userType === UserTypeEnum.CONSUMER && (
        <Text>
          <Trans
            i18nKey='signUp.viewTermsConsumer'
            components={[
              <DisabledLink
                disabled
                key={0}
                data-test-terms-link
                target='_blank'
                onClick={() => setFieldTouched('country')}
              />,
              <DisabledLink
                key={1}
                disabled
                data-test-eula-link
                target='_blank'
                onClick={() => setFieldTouched('country')}
              />,
            ]}
          />
        </Text>
      )}

      {isPartnerLike && (
        <DisabledLink
          data-test-terms-link
          disabled
          target='_blank'
          onClick={() => setFieldTouched('country')}>
          {t('signUp.viewTerms')}
        </DisabledLink>
      )}
    </>
  );
};

export default DisabledLinks;
